export function amendmentByType(item: any, type: any) {
  return item.amendment && item.amendment.type === type ? item.amendment : null;
}

export const Types = {
  INCLUDE: 'INCLUDE',
  EXCLUDE: 'EXCLUDE'
};
